import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ec96cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subscription-price" }
const _hoisted_2 = { class: "plan-price" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "$", -1))
const _hoisted_5 = { class: "price-whole" }
const _hoisted_6 = {
  key: 0,
  class: "price-decimal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plan-interval" }, "/month", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "plan-term"
}

import { computed } from 'vue'
import { SubscriptionPlan } from '@/gp/GroupAdminModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionPrice',
  props: {
    plan: {}
  },
  setup(__props: any) {

const props = __props;



const termPriceRef = computed(() => ((props.plan.price ?? 0) * (props.plan.termMonths ?? 12)).toFixed(2))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.plan.price)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(Math.floor(props.plan.price)), 1),
            (props.plan.price % 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((props.plan.price % 1).toFixed(2).substring(2)), 1))
              : _createCommentVNode("", true),
            _hoisted_7
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, "Free"))
    ]),
    (props.plan.termMonths)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " $" + _toDisplayString(termPriceRef.value) + " for " + _toDisplayString(props.plan.termMonths) + " months ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})